module.exports = __webpack_public_path__ + "img/person-img2.aa77641d.png";